/**
 * Create config common to line chart types
 */
export var createLineConfig = function (options) {
    return {
        line: {
            // Thin stroke lines
            strokeWidth: 1.5
        }
    };
};
